import { developmentMode } from '/shared/util/Statics';

import Footer from '/business/shared/components/widgets/footer/Footer';
import DebugFooter from '/business/shared/components/debug/DebugFooter';

function ApplicationLayoutFooter() {
  return (
    <>
      <Footer />
      {developmentMode && <DebugFooter />}
    </>
  );
}

export default ApplicationLayoutFooter;
